module.exports = __webpack_public_path__ + "friend4.png?f5468a59e1e3faeb6ebedfbfe66a49bd";


//////////////////
// WEBPACK FOOTER
// ./static/assets/friend4.png
// module id = 477
// module chunks = 0